import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "graph",
  "use": "graph-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"graph\"><title>graph</title><path d=\"M14.769 6.154c.246-.246.369-.615.369-.985s-.123-.738-.369-.985c-.369-.369-1.108-.492-1.6-.246l-2.092-1.969c.123-.246.246-.369.246-.615 0-.369-.123-.738-.369-.985-.492-.492-1.354-.492-1.846 0-.369.369-.492.615-.492.985s.123.738.369.985L6.4 6.893c-.123 0-.246-.123-.369-.123a.94.94 0 0 0-.615.246L3.324 5.047c.369-.492.246-1.231-.246-1.6-.369-.615-1.354-.615-1.846-.123-.492.615-.492 1.354 0 1.969.246.246.615.369.985.369.246 0 .492-.123.738-.246l1.969 2.092c-.123.246-.246.492-.246.615 0 .369.123.738.369.985s.615.369.985.369c.369 0 .738-.123.985-.369.492-.492.492-1.354 0-1.969l2.585-4.554c.123 0 .246.123.369.123.246 0 .492-.123.738-.246l1.969 1.969c-.123.246-.246.492-.246.738 0 .369.123.738.369.985s.615.369.985.369c.369 0 .738-.123.985-.369zm-1.107 3.077V16H16V9.231h-2.338zM9.108 16h2.338V5.292H9.108V16zm-4.554 0h2.338v-3.692H4.554V16zM0 16h2.338V8.369H0V16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/graph.svg
// module id = 26
// module chunks = 0